import React, { useRef } from 'react';
import {
    Grid,
    Paper,
    Typography,
    FormGroup,
    Button
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { withCookies } from 'react-cookie';
import PropTypes from 'prop-types';
import QRCode from "react-qr-code";
import ReactToPrint from "react-to-print";
import Print from "./Print"

const useStyles = makeStyles({
    paper: {
        marginTop: '5px',
        minWidth: 900,
        textAlign: 'center',
        justifyContent: 'center',
    },
    inputAddress: {
        marginTop: '35px',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight:'82px',
    },
    title:{
        marginTop: '30px',
        justifyContent: 'center',
        textAlign:'center',
    },
    inputKeyword:{
        fontSize:'20px',
        margin: '0px 0px 10px 300px',
        textAlign:'left',
        width: 'auto'
    },
    displayFlex: {
        display: 'flex'
    },
    verticalSpace: {
        margin: '25px 20px 20px 100px',
    },
    searchButtonSpace: {
        margin: '25px 0px 10px 10px',
        fontSize:'18px',
    },
    qr:{
        marginTop: '30px',
        alignItems: 'center',
        justifyContent: 'center',
    },
    left:{
        display: 'inline-block',
    },
    marginAuto:{
        fontSize:'20px',
        margin: '0px auto 10px 25px',
        width: 200
    },
    conditionLeft: {
        fontSize:'20px',
        textAlign:'left',
    },
    printDescriptionArea:{
        marginTop:'20px'
    },
    printDescription:{
        textAlign:'left',
        marginTop: '10px',
        marginLeft: '250px',
        fontSize: '18px'
    },
    printButton:{
        marginTop: '20px',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight:'82px',
    }
});
const QRPreview = withCookies((props) => {
    const {
        categoryId,
        categoryName,
        liffUrl,
        nameObj,
        displayNickName,
        setPreviewFlg,
        nickName,
        encodedAddress,
        setNickName
    } = props;
    const classes = useStyles();
    const componentRef = useRef();
    const src = {
        categoryId,
        encodedAddress,
        categoryName: categoryName[0].label,
        address: encodedAddress,
        liffUrl,
        nickName,
        displayNickName
    };

    const backButtonClick = () => {
        setPreviewFlg(false);
        setNickName('');
    }

    return (
        <React.Fragment>
            <div elevation={3} className={classes.paper} >
                <div className={classes.left}>
                    <Typography className={classes.title} variant="h4" component="p">
                        {nameObj.PRINT_TITLE}
                    </Typography>
                    <Paper elevation={2} variant="outlined" className={classes.paper}></Paper>
                    <FormGroup className={classes.inputAddress} row>
                        <Typography variant="h3" className={classes.inputKeyword}>
                            {`${nameObj.KUBUN_NAME}：`}
                        </Typography>
                        <div className={classes.marginAuto}>
                            <Typography variant="h3" className={classes.conditionLeft}>
                                {`${categoryName[0].label}`}
                            </Typography>
                        </div>
                    </FormGroup>
                    <FormGroup className={classes.inputAddress} row>
                        <Typography variant="h3" className={classes.inputKeyword}>
                            {`${nameObj.PRINT_ADDRESS_NAME}：`}
                        </Typography>
                        <div className={classes.marginAuto}>
                            <Typography variant="h3" className={classes.conditionLeft}>
                                {`${encodedAddress}`}
                            </Typography>
                        </div>
                    </FormGroup>
                    <FormGroup className={classes.inputAddress} row>
                        <Typography variant="h3" className={classes.inputKeyword}>
                            {`${nameObj.PRINT_USER_NAME}：`}
                        </Typography>
                        <div className={classes.marginAuto}>
                            <Typography variant="h3" className={classes.conditionLeft}>
                                {`${nickName} ${nameObj.PRINT_NAME_HONORIFICS}`}
                            </Typography>
                        </div>
                    </FormGroup>
                    <FormGroup className={classes.qr} row>
                        <div style={{ height: "auto", margin: "0 auto", maxWidth: 300, width: "100%" }}>
                            <QRCode
                                size={300}
                                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                value={`${liffUrl}/?cid=${categoryId}&addId=${encodedAddress}`}
                                viewBox={`0 0 300 300`}
                            />
                        </div>
                    </FormGroup>
                    <FormGroup className={classes.printDescriptionArea}>　
                        {nameObj.PRINT_DESCRIPTION.split('\n').map((line) => {
                            return (
                                <div className={classes.printDescription}>{line}</div>
                            )
                        })}
                    </FormGroup>
                    <FormGroup className={classes.inputAddress} row>
                        <Grid>
                            <div>
                                <div className={classes.displayFlex + ' ' + classes.verticalSpace}>
                                    <Button size="large" className={classes.searchButtonSpace} variant="contained" onClick={() => backButtonClick()}>戻る</Button>
                                </div>
                            </div>
                        </Grid>
                        <Grid>
                            <div>
                                <div className={classes.displayFlex + ' ' + classes.verticalSpace}>
                                    <ReactToPrint trigger={() => (
                                        <Button color="primary" size="large" className={classes.searchButtonSpace} variant="contained">印刷</Button>
                                        )}
                                        content={() => componentRef.current}
                                        pageStyle={`@page { size: ${nameObj.PRINT_SIZE} }`}
                                    >
                                    </ReactToPrint>
                                    <div style={{ display: "none" }}>
                                        <Print
                                            ref={componentRef}
                                            src={src}
                                            nameObj={nameObj}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Grid>
                    </FormGroup>
                </div>
            </div>
        </React.Fragment>
    );
});

QRPreview.propTypes = {
    classes: PropTypes.object.isRequired,
    categoryId: PropTypes.string.isRequired,
    setPreviewFlg:PropTypes.func.isRequired,
    categoryName: PropTypes.array.isRequired,
    liffUrl: PropTypes.string.isRequired,
    nameObj: PropTypes.object.isRequired,
    displayNickName: PropTypes.bool.isRequired,
    encodedAddress: PropTypes.string.isRequired,
    cookies: PropTypes.object.isRequired,
};

export default withCookies(QRPreview);
